"use client";
//#region packages/@mantine/core/src/core/utils/is-number-like/is-number-like.ts
function isNumberLike(value) {
	if (typeof value === "number") return true;
	if (typeof value === "string") {
		if (value.startsWith("calc(") || value.startsWith("var(") || value.includes(" ") && value.trim() !== "") return true;
		const cssUnitsRegex = /^[+-]?[0-9]+(\.[0-9]+)?(px|em|rem|ex|ch|lh|rlh|vw|vh|vmin|vmax|vb|vi|svw|svh|lvw|lvh|dvw|dvh|cm|mm|in|pt|pc|q|cqw|cqh|cqi|cqb|cqmin|cqmax|%)?$/;
		return value.trim().split(/\s+/).every((val) => cssUnitsRegex.test(val));
	}
	return false;
}
//#endregion
export { isNumberLike };

//# sourceMappingURL=is-number-like.mjs.map